module.exports = __webpack_public_path__ + "img/developer-2.a13f39d4.jpeg";